<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="pb-0 bg-transparent card-header text-start">
                  <h4 class="font-weight-bolder">Iniciar sesión</h4>
                  <p class="mb-0 text-sm">
                    Ingrese sus credenciales para acceder al cotizador.
                  </p>
                </div>
                <div class="card-body">
                  <form
                    role="form"
                    @submit.prevent="validateCredentials"
                    id="formLogin"
                  >
                    <div class="mb-3">
                      <argon-input
                        type="text"
                        placeholder="Usuario"
                        name="email"
                        size="lg"
                        :required="true"
                      />
                    </div>
                    <div class="mb-3">
                      <argon-input
                        type="password"
                        placeholder="Contraseña"
                        name="password"
                        size="lg"
                        :required="true"
                      />
                    </div>
                    <argon-switch id="rememberMe" checked="true"
                      ><small class="text-secondary"
                        >Recordar credenciales</small
                      ></argon-switch
                    >

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="warning"
                        fullWidth
                        size="lg"
                        :disabled="botonCargando"
                      >
                        <span
                          class="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"
                          v-if="botonCargando"
                        ></span>
                        Acceder</argon-button
                      >
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <small>
                    ©
                    {{ new Date().getFullYear() }}, desarrollado por
                    <a href="https://devratio.com.mx" target="_blank"
                      ><span id="dev">dev</span><span id="Ratio">Ratio</span></a
                    >
                  </small>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="
                  background-image: url('https://images.pexels.com/photos/2887582/pexels-photo-2887582.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1');
                  background-size: cover;
                "
              >
                <span class="mask bg-gradient-dark opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >
                  <img :src="brandImg" width="150" class="mb-4" alt="imgLogo" />
                  <br />
                  "La mejor alternativa para crecer"
                </h4>
                <p class="text-white position-relative">
                  La solución flexible que buscabas, te escuchamos y nos
                  ajustamos a tus necesidades.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];
import { useLogin } from "@/composables/useAuth";

export default {
  name: "signin",
  components: {
    ArgonInput,
    ArgonSwitch,
    ArgonButton,
  },
  computed: {
    brandImg() {
      return require(`@/assets/img/${process.env.VUE_APP_BRAND}/logo-horizontal-light.png`);
    },
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  setup() {
    const { botonCargando, validateCredentials } = useLogin();

    return {
      botonCargando,
      validateCredentials,
    };
  },
};
</script>

<style scoped>
main {
  background-color: #e5e5f7;
  background-image: repeating-radial-gradient(
      circle at 0 0,
      transparent 0,
      #ffffff 9px
    ),
    repeating-linear-gradient(#fafafa55, #ffffff);
}
</style>
